import * as Sentry from '@sentry/react';
import { J_PASSWORD, J_USERNAME, PASSWORD, PHONE } from 'apps/auth/constants/Constants';
import {
    AUTH_TYPE,
    CAN_SEND_MONEY_BY_CARD_FROM_USER_COUNTRY,
    RESTORE_PASSWORD,
    SHOW_DISCLAIMER,
    SHOW_WAITING_LIST_DISCLAIMER,
} from 'apps/auth/constants/ExtraNames';
import { BIRTHDAY, NAME, POST_CODE } from 'apps/auth/constants/fieldsName';
import { LOGIN_REGISTRATION_FORM_NAME } from 'apps/auth/constants/formName';
import { UNITED_ARAB_EMIRATES, USA } from 'apps/auth/constants/WellKnownCountries';

import {
    CANCEL_REASON_PASSCODE_SCREEN,
    DISCLAIMER_SCREEN,
    FILL_PROFILE_SCREEN,
    HAS_PASSWORD,
    INSERT_PASSWORD,
    INSERT_PHONE_SCREEN,
    NEW_USER,
    PASSCODE_SCREEN,
    RESTORE_PASSWORD_SCREEN,
    SIMPLE_REGISTRATION,
    SMS_CONFIRMATION_SCREEN,
    WAITING_LIST,
    WITH_PASSCODE,
    WITHOUT_PASSWORD,
} from './constants';

const formName = LOGIN_REGISTRATION_FORM_NAME;
const NAME_FORM_ACTION = '/registration/second/screen';
const ADDRESS_FORM_ACTION = '/registration/third/screen';
const EMAIL_FORM_ACTION = '/registration.action';
const EMAIL_FORM_ACTION_TERMS = '/registration/terms/screen';
const WAITING_LIST_ACTION = '/waiting/list/enter-email.action';
const usaDateFormat = '^(0[1-9]|1[012])\\/(0[1-9]|[12][0-9]|3[01])\\/(1[9]|2[0])\\d{2}$';

export const switchScreen = (screen, isBackFlow, authType, showDisclaimer, showWaitingListDisclaimer, restorePassword, simpleRegistration) => {
    let newScreen = screen;
    if (simpleRegistration && authType === NEW_USER) {
        if (screen === INSERT_PHONE_SCREEN && !isBackFlow) {
            newScreen = SIMPLE_REGISTRATION;
        } else if (screen === SIMPLE_REGISTRATION && showDisclaimer && !isBackFlow) {
            newScreen = DISCLAIMER_SCREEN;
        }
    } else if (screen === INSERT_PHONE_SCREEN && !isBackFlow) {
        if (authType === NEW_USER) {
            if (showDisclaimer) {
                newScreen = DISCLAIMER_SCREEN;
            } else if (showWaitingListDisclaimer) {
                newScreen = WAITING_LIST;
            } else {
                newScreen = FILL_PROFILE_SCREEN;
            }
        } else if (authType === HAS_PASSWORD) {
            restorePassword ? (newScreen = RESTORE_PASSWORD_SCREEN) : (newScreen = INSERT_PASSWORD);
        } else if (authType === WITH_PASSCODE) {
            newScreen = PASSCODE_SCREEN;
        }
    }
    return newScreen;
};

const resetInsertPhone = (updateFormProperties, updateExtraByName) => {
    updateFormProperties(formName, null, false);
    updateExtraByName(AUTH_TYPE, null);
};

export const handleBackFlow = (
    authType,
    screen,
    showDisclaimer,
    termsDisclaimerText,
    showWaitingListDisclaimer,
    action,
    phoneCountryId,
    updateFormProperties,
    updateExtraByName,
    changeFieldProperty,
    updatePageMessages,
    fillProfileFormMessages,
    fields,
    canSendMoneyByCardFromUserCountry,
    fieldsForScreens,
    restorePassword,
    countriesWithDisclaimer,
    simpleRegistration,
    createPasscode,
    showFeedbackCancellationReasons,
    redirectUrl,
) => {
    let newScreen = screen;
    if (screen === SMS_CONFIRMATION_SCREEN) {
        if (authType === HAS_PASSWORD) {
            newScreen = INSERT_PASSWORD;
        } else if (authType === WITHOUT_PASSWORD) {
            newScreen = INSERT_PHONE_SCREEN;
            resetInsertPhone(updateFormProperties, updateExtraByName);
        } else {
            if (showDisclaimer && countriesWithDisclaimer) {
                newScreen = DISCLAIMER_SCREEN;
            } else if (simpleRegistration) {
                newScreen = SIMPLE_REGISTRATION;
            } else {
                newScreen = FILL_PROFILE_SCREEN;
                toFillProfileEmail(changeFieldProperty, updatePageMessages, updateFormProperties, fillProfileFormMessages, fields, fieldsForScreens);
            }
        }
    } else if (screen === FILL_PROFILE_SCREEN) {
        if (action === NAME_FORM_ACTION) {
            newScreen = INSERT_PHONE_SCREEN;
            resetInsertPhone(updateFormProperties, updateExtraByName);
            canSendMoneyByCardFromUserCountry ? updateExtraByName(CAN_SEND_MONEY_BY_CARD_FROM_USER_COUNTRY, false) : null;
            showDisclaimer ? updateExtraByName(SHOW_DISCLAIMER, false) : null;
        } else if (action === WAITING_LIST_ACTION) {
            newScreen = INSERT_PHONE_SCREEN;
            resetInsertPhone(updateFormProperties, updateExtraByName);
        } else if (action === ADDRESS_FORM_ACTION) {
            toFillProfileName(changeFieldProperty, updatePageMessages, updateFormProperties, fillProfileFormMessages, fields, fieldsForScreens);
        } else {
            toFillProfileAddress(
                changeFieldProperty,
                updatePageMessages,
                updateFormProperties,
                fillProfileFormMessages,
                fields,
                fieldsForScreens,
                phoneCountryId,
            );
        }
    } else if (screen === RESTORE_PASSWORD_SCREEN) {
        newScreen = INSERT_PASSWORD;
        updateFormProperties(formName, null, false);
        updateExtraByName(RESTORE_PASSWORD, false);
        changeFieldProperty(formName, PHONE, NAME, J_USERNAME);
        changeFieldProperty(formName, PASSWORD, NAME, J_PASSWORD);
    } else if (screen === INSERT_PASSWORD) {
        newScreen = INSERT_PHONE_SCREEN;
        resetInsertPhone(updateFormProperties, updateExtraByName);
        changeFieldProperty(formName, PHONE, NAME, PHONE);
    } else if (screen === DISCLAIMER_SCREEN) {
        if (phoneCountryId === USA && !action) {
            newScreen = INSERT_PHONE_SCREEN;
            resetInsertPhone(updateFormProperties, updateExtraByName);
            updateExtraByName(SHOW_DISCLAIMER, false);
        } else if (simpleRegistration) {
            newScreen = SIMPLE_REGISTRATION;
        } else {
            newScreen = FILL_PROFILE_SCREEN;
            toFillProfileEmail(
                changeFieldProperty,
                updatePageMessages,
                updateFormProperties,
                fillProfileFormMessages,
                fields,
                fieldsForScreens,
                countriesWithDisclaimer,
            );
        }
    } else if (screen === WAITING_LIST) {
        newScreen = INSERT_PHONE_SCREEN;
        resetInsertPhone(updateFormProperties, updateExtraByName);
        updateExtraByName(SHOW_WAITING_LIST_DISCLAIMER, false);
    } else if (screen === SIMPLE_REGISTRATION) {
        newScreen = INSERT_PHONE_SCREEN;
        resetInsertPhone(updateFormProperties, updateExtraByName);
    } else if (screen === PASSCODE_SCREEN && createPasscode && showFeedbackCancellationReasons && canUserSeeCancelPasscodeSurvey()) {
        newScreen = CANCEL_REASON_PASSCODE_SCREEN;
    } else if (screen === PASSCODE_SCREEN && createPasscode) {
        window.location.replace(redirectUrl);
    }
    return newScreen;
};

export const toFillProfileName = (changeFieldProperty, updatePageMessages, updateFormProperties, fillProfileFormMessages, fields, fieldsForScreens) => {
    const { headerTitleName, headerGrayTitleName } = fillProfileFormMessages;
    Object.values(fields).forEach((field) => {
        if (fieldsForScreens?.[0]?.includes(field.name)) {
            changeFieldProperty(formName, field.name, 'visible', true);
        } else {
            changeFieldProperty(formName, field.name, 'visible', false);
        }
    });
    updatePageMessages({
        headerTitle: headerTitleName,
        headerGrayTitle: headerGrayTitleName,
    });
    updateFormProperties(formName, NAME_FORM_ACTION);
};

const toFillProfileAddress = (
    changeFieldProperty,
    updatePageMessages,
    updateFormProperties,
    fillProfileFormMessages,
    fields,
    fieldsForScreens,
    phoneCountryId,
) => {
    const { headerTitleAddress, headerGrayTitleAddress } = fillProfileFormMessages;
    Object.values(fields).forEach((field) => {
        if (fieldsForScreens?.[1]?.includes(field.name)) {
            if (phoneCountryId === UNITED_ARAB_EMIRATES && field.name === POST_CODE) {
                changeFieldProperty(formName, field.name, 'visible', false);
            } else {
                changeFieldProperty(formName, field.name, 'visible', true);
            }
        } else {
            changeFieldProperty(formName, field.name, 'visible', false);
        }
    });
    updatePageMessages({
        headerTitle: headerTitleAddress,
        headerGrayTitle: headerGrayTitleAddress,
    });
    updateFormProperties(formName, ADDRESS_FORM_ACTION);
};

const toFillProfileEmail = (
    changeFieldProperty,
    updatePageMessages,
    updateFormProperties,
    fillProfileFormMessages,
    fields,
    fieldsForScreens,
    countriesWithDisclaimer,
) => {
    const { headerTitleEmail, headerGrayTitleEmail } = fillProfileFormMessages;
    Object.values(fields).forEach((field) => {
        if (fieldsForScreens?.[2]?.includes(field.name)) {
            changeFieldProperty(formName, field.name, 'visible', true);
        } else {
            changeFieldProperty(formName, field.name, 'visible', false);
        }
    });
    updatePageMessages({
        headerTitle: headerTitleEmail,
        headerGrayTitle: headerGrayTitleEmail,
    });
    const action = countriesWithDisclaimer ? EMAIL_FORM_ACTION_TERMS : EMAIL_FORM_ACTION;
    updateFormProperties(formName, action);
};

export const getForms = (action, changeFieldProperty, updatePageMessages, updateFormProperties, fillProfileFormMessages, fields, fieldsForScreens) => {
    if (!action) {
        toFillProfileName(changeFieldProperty, updatePageMessages, updateFormProperties, fillProfileFormMessages, fields, fieldsForScreens);
    }
};

const changeFieldValue = (value, changeFieldProperty, isCurrentValueUsaFormat) => {
    let dd, mm, yyyy;
    let newValue;
    dd = isCurrentValueUsaFormat ? `${value[2]}${value[3]}` : `${value[0]}${value[1]}`;
    mm = isCurrentValueUsaFormat ? `${value[0]}${value[1]}` : `${value[2]}${value[3]}`;
    yyyy = `${value[4]}${value[5]}${value[6]}${value[7]}`;
    newValue = isCurrentValueUsaFormat ? `${dd}.${mm}.${yyyy}` : `${mm}/${dd}/${yyyy}`;
    changeFieldProperty(formName, BIRTHDAY, 'value', newValue);
};

export const changeBirthdayDateFormat = (birthdayField, changeFieldProperty) => {
    const { value, checkRegexp } = birthdayField;
    const numberValue = value.replace(/[^0-9]+/g, '');
    if (numberValue.length === 8) {
        const isCurrentValueUsaFormat = value.includes('/');
        if ((checkRegexp !== usaDateFormat && isCurrentValueUsaFormat) || (checkRegexp === usaDateFormat && !isCurrentValueUsaFormat)) {
            changeFieldValue(numberValue, changeFieldProperty, isCurrentValueUsaFormat);
        }
    }
};

export const canUserSeeCancelPasscodeSurvey = () => {
    if (localStorage) {
        try {
            let data = JSON.parse(localStorage.getItem('cancelPasscodeSurveyInfo'));
            if (data) {
                if (data.alreadySeenCancelPasscodeSurvey) {
                    return data.hideUntil < new Date().getTime();
                } else {
                    return true;
                }
            }
        } catch (e) {
            Sentry.captureException(e, {
                level: 'warning',
            });
            return true;
        }
    }
    return true;
};

export const setUserAlreadySeenCancelPasscodeSurvey = () => {
    if (localStorage) {
        let surveyInfo = { alreadySeenCancelPasscodeSurvey: true, hideUntil: new Date().getTime() + 1000 * 60 * 60 * 24 * 7 };
        localStorage.setItem('cancelPasscodeSurveyInfo', JSON.stringify(surveyInfo));
    }
};
